import React, { useState, useEffect, useRef } from 'react';

export const RefreshTimer = ({ isRefreshing }) => {
  const [secondsSinceUpdate, setSecondsSinceUpdate] = useState(0);
  const timerIntervalRef = useRef(null);

  useEffect(() => {
    timerIntervalRef.current = setInterval(() => {
      setSecondsSinceUpdate(prev => prev + 1);
    }, 1000);

    return () => {
      if (timerIntervalRef.current) {
        clearInterval(timerIntervalRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (!isRefreshing) {
      setSecondsSinceUpdate(0);
    }
  }, [isRefreshing]);

  return (
    <div className="auto-refresh-timer">
      {isRefreshing ? (
        <span className="refresh-status">Обновление...</span>
      ) : (
        <span className="refresh-status">
          Обновлено {secondsSinceUpdate} сек. назад
        </span>
      )}
    </div>
  );
};
